import { useState } from 'react';
import { COMPANY_PROFILE } from '../../../constants/constants';
import { COMMON } from '../../../constants/commonText.constants';
import { observer } from 'mobx-react-lite';
import { useCompanyStore } from '..';
import { useTran } from '../../../hooks/useTran';
import { COMPANY } from '../constants/companyText.constants';
import { COMPANY_TYPE_OPTIONS, INDUSTRIAL_CLASSIFICATION } from '../../OnBoard/constants/onboard.constant';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Modal } from '@/components/ui/modal';
import { Select } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';
const CreateCompanyModal = observer(({ openCreateUserModal }) => {
	const { t } = useTran();
	const { t: countryT } = useTran('countries');
	const {
		companyForm,
		setCompanyFormValue,
		setCompanyForm,
		saveCompany,
		errors,
		isCompanyModalOpen,
		closeCompanyModal,
		countryList,
		getCompanies,
	} = useCompanyStore();

	const [loading, setLoading] = useState(false);

	const _handleCreate = () => {
		setLoading(true);
		saveCompany().then((success) => {
			if (success) {
				closeCompanyModal();
				if (openCreateUserModal) openCreateUserModal();
			}
			setLoading(false);
		});
	};

	const _handleCancel = () => {
		setCompanyForm();
		getCompanies();
		closeCompanyModal();
		if (openCreateUserModal) openCreateUserModal();
	};

	const { _id, companyName, country, businessNo, companyType, industrySector, address } = companyForm || {};

	return (
		<Modal
			isOpen={isCompanyModalOpen}
			onClose={_handleCancel}
			title={t(_id ? COMPANY.EDIT_COMPANY : COMPANY.CREATE_COMPANY)}
			isStatic
			footer={
				<div className="flex gap-2 items-center justify-end">
					<Button
						onClick={_handleCancel}
						variant="secondary"
					>
						{t(COMMON.CANCEL)}
					</Button>
					<Button
						id={'saveCompany'}
						loading={loading}
						onClick={_handleCreate}
					>
						{t(COMMON.SAVE)}
					</Button>
				</div>
			}
		>
			<div className="grid grid-cols-2 gap-3">
				<Input
					label={t(COMMON.COMPANY_NAME)}
					placeholder={t(COMMON.COMPANY_NAME)}
					id="companyName"
					value={companyName}
					onChange={setCompanyFormValue}
					error={errors.companyName}
				/>
				<Select
					label={t(COMPANY_PROFILE.LOCATION)}
					placeholder={t(COMPANY_PROFILE.SELECT_LOCATION)}
					options={countryList}
					id="country"
					value={country}
					onChange={setCompanyFormValue}
					error={errors.country}
					customT={countryT}
				/>
				<Select
					label={t(COMPANY_PROFILE.COMPANY_TYPE)}
					placeholder={t(COMPANY_PROFILE.COMPANY_TYPE)}
					options={COMPANY_TYPE_OPTIONS}
					id="companyType"
					value={companyType}
					onChange={setCompanyFormValue}
					error={errors.companyType}
				/>
				<Select
					label={t(COMPANY_PROFILE.INDUSTRY_SECTOR)}
					placeholder={t(COMPANY_PROFILE.INDUSTRY_SECTOR)}
					options={INDUSTRIAL_CLASSIFICATION}
					id="industrySector"
					value={industrySector}
					onChange={setCompanyFormValue}
					error={errors.industrySector}
				/>
				<Textarea
					className="col-span-2"
					label={t(COMMON.ADDRESS)}
					placeholder={t(COMMON.ADDRESS)}
					id="address"
					value={address}
					onChange={setCompanyFormValue}
					error={errors.address}
				/>
			</div>
		</Modal>
	);
});

export default CreateCompanyModal;
